import { httpClient } from '../dataProvider'
import { API_URL } from '../constants';

export const listMedia = async (page: number = 1, limit: number = 10, sortBy: string = 'createdAt', sortOrder: 'DESC' | 'ASC' = 'DESC') => {
  const { json } = await httpClient(`${API_URL}/media?_page=${page}&_limit=${limit}&_sort=${sortBy}&_order=${sortOrder}`);
  return json
}